import type { UserSettings, MusicalScale } from '../types';

const DEFAULT_SETTINGS: UserSettings = {
  sensitivity: 1.0,
  waveType: 'sine',
  volume: 0.3,
  scale: 'major',
};

const STORAGE_KEY = 'hum-canvas-settings';

export function loadSettings(): UserSettings {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return { ...DEFAULT_SETTINGS, ...JSON.parse(stored) };
    }
  } catch { /* ignore */ }
  return { ...DEFAULT_SETTINGS };
}

export function saveSettings(settings: UserSettings): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch { /* ignore */ }
}

export function initControls(
  onChange: (settings: UserSettings) => void,
  onTimbreChange?: (waveType: OscillatorType) => void,
): void {
  const sensitivity = document.getElementById('sensitivity') as HTMLInputElement;
  const waveType = document.getElementById('timbre-select') as HTMLSelectElement;
  const scaleSelect = document.getElementById('scale-select') as HTMLSelectElement;
  const volume = document.getElementById('volume') as HTMLInputElement;
  const toggle = document.getElementById('settings-toggle') as HTMLButtonElement;
  const panel = document.getElementById('settings-panel') as HTMLDivElement;

  const settings = loadSettings();
  sensitivity.value = String(settings.sensitivity);
  waveType.value = settings.waveType;
  if (scaleSelect) scaleSelect.value = settings.scale || 'major';
  volume.value = String(settings.volume);

  const emit = () => {
    const s: UserSettings = {
      sensitivity: parseFloat(sensitivity.value),
      waveType: waveType.value as OscillatorType,
      volume: parseFloat(volume.value),
      scale: (scaleSelect?.value as MusicalScale) || 'major',
    };
    saveSettings(s);
    onChange(s);
  };

  sensitivity.addEventListener('input', emit);
  waveType.addEventListener('change', () => {
    emit();
    if (onTimbreChange) onTimbreChange(waveType.value as OscillatorType);
  });
  if (scaleSelect) scaleSelect.addEventListener('change', emit);
  volume.addEventListener('input', emit);

  toggle.addEventListener('click', () => {
    panel.classList.toggle('hidden');
  });
}
